//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    parameters: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {};
  }
};